import { Box, Divider, Grid, Rating, Typography, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

import ApiContext from 'contexts/apiContext';
import EmptyState from 'common/EmptyState';
import { Pagination } from '@mui/material';
import RefreshIndicator from 'common/RefreshIndicator';
import Spinner from 'common/Spinner';
import StoreContext from 'contexts/storeContext';
import { makeStyles } from 'tss-react/mui';
import { Review } from 'types/review';
import ReviewCard from 'components/ReviewCard';

const useStyles = makeStyles()((theme) => ({
  paginationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
}));

export default function ReviewsScreen() {
  const { classes } = useStyles();
  const { store } = useContext(StoreContext);
  const { api } = useContext(ApiContext);
  const [reviews, setReviews] = useState<Review[]>([]);
  const mobile = useMediaQuery('(max-width: 600px)');
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  // pagination
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    setRefreshing(true);
    api.reviews.list(store.id, { page }).then((response) => {
      setReviews(response.data.results);
      setNumPages(response.data.num_pages);
      setLoading(false);
      setRefreshing(false);
    });
  }, [api, page, store.id]);

  const handlePagination = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='center' flexWrap='wrap'>
        <Typography sx={{ mr: 1 }} variant='h6' noWrap>
          Calificación promedio
        </Typography>
        <Rating value={store.average_rating} precision={0.1} readOnly />
        <Typography variant='h6' sx={{ fontWeight: 'bold', ml: 2, mr: 5 }} display='inline'>
          {store.average_rating.toFixed(1)}
        </Typography>
        <Typography variant='h6' noWrap>
          {store.reviews_count} reseñas
        </Typography>
      </Box>
      <Box display='flex' alignItems='center' justifyContent='center' flexWrap='wrap' sx={{ mb: 2, mt: 1 }}>
        <Typography sx={{ mr: 1, fontWeight: 600 }} noWrap>
          Calidad de packs
        </Typography>
        <Rating value={store.rating_food_quality} sx={{ mr: 2 }} precision={0.1} readOnly size='small' />
        <Typography sx={{ mr: 1, fontWeight: 600 }} noWrap>
          Tamaño de packs
        </Typography>
        <Rating value={store.rating_food_quantity} sx={{ mr: 2 }} precision={0.1} readOnly size='small' />
        <Typography sx={{ mr: 1, fontWeight: 600 }} noWrap>
          Experiencia en tienda
        </Typography>
        <Rating value={store.rating_store_experience} sx={{ mr: 2 }} precision={0.1} readOnly size='small' />
      </Box>
      <Divider sx={{ mb: 2 }} />
      {loading ? (
        <Spinner />
      ) : (
        <>
          <RefreshIndicator visible={refreshing} />
          {reviews?.length === 0 ? (
            <EmptyState title='¡Aún no tienes reseñas!' infoLines={['Publica y vende packs para que los usuarios puedan evaluarlos.']} />
          ) : (
            <Grid container spacing={2}>
              {reviews.map((review) => (
                <Grid item key={review.id} xs={12} sm={4} lg={3} xl={2}>
                  <ReviewCard review={review} />
                </Grid>
              ))}
            </Grid>
          )}
          <Box className={classes.paginationContainer}>
            <Pagination
              count={numPages}
              page={page}
              color='primary'
              size={mobile ? 'small' : 'large'}
              siblingCount={0}
              boundaryCount={1}
              onChange={handlePagination}
            />
          </Box>
        </>
      )}
    </>
  );
}
